import {CSSProperties, memo, useMemo} from "react";
import {CELL_SIZE} from "../../utility/types";
import {Vec2} from "../../utility/math/vec2";

export const SelectionBorder = memo(({position}: {position: Vec2}) => {
  const worldPos = position.mulScalar(CELL_SIZE).addScalar(0.5 * CELL_SIZE);

  const borderStyle = useMemo<CSSProperties>(
    () => ({
      position: "absolute",
      top: 0,
      left: 0,
      transform: `translate(${worldPos.x}px, ${worldPos.y}px) translate(-50%, -50%)`,
      width: `${CELL_SIZE}px`,
      height: `${CELL_SIZE}px`,
      borderRadius: "var(--chakra3-radii-md)",
      border: "2px dashed var(--chakra3-colors-blue-500)",
      backgroundColor: "var(--chakra3-colors-blue-100)",
      boxSizing: "border-box",
    }),
    [worldPos.x, worldPos.y],
  );

  return <div style={borderStyle} />;
});
